export const getRouteName = () => {
  if (window) {
    if (location.pathname.includes("page") || location.pathname === "/") {
      return location.pathname.split("/").slice(0, -2).join("/") || "ROOT"
    }
  }
}
